var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var SvgTextIndent = function (props) { return (_jsxs("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 18 18", width: "1em", height: "1em" }, props, { children: [_jsx("path", { stroke: "currentColor", strokeMiterlimit: 10, strokeWidth: 1.25, d: "M2.67 4.313h13.08M7.658 9h8.092M2.67 13.688h13.08" }), _jsx("path", { fill: "currentColor", d: "m6.26 9-3.42 2.552V6.448z" })] }))); };
export default SvgTextIndent;
